export const deepOrange50 = "#fdebe8";
export const deepOrange100 = "#fde1d7";
export const deepOrange200 = "#fbc3b0";
export const deepOrange300 = "#faa589";
export const deepOrange400 = "#f88762";
export const deepOrange500 = "#f76a3b";
export const deepOrange600 = "#ef552f";
export const deepOrange700 = "#e74023";
export const deepOrange800 = "#de2b18";
export const deepOrange900 = "#d7160c";
export const deepOrange1000 = "#d00902";
export const deepOrangeA100 = "#fdbe6a";
export const deepOrangeA200 = "#fb9f58";
export const deepOrangeA400 = "#f3351d";
export const deepOrangeA500 = "#ec0804";
export const deepOrangeA1000 = "#562414";
